module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/paperwalletemptyFgGreen.212e106aac1e39aa7348857e1e8b53ee.svg";